import { Card } from "antd";
import React, { useEffect } from "react";
import Filterbox from "../../ui/FilterBox/Filterbox";
import SapaHeader from "../../ui/Header/Header";
import { apiProvidersColumn } from "../../DummyAPI/TableData/Columns";
import ProgressLoader from "../../components/Loader/ProgressLoader";
import { useDispatch, useSelector } from "react-redux";
import { selectProvidersData, selectProvidersLoading } from './../../redux/selectors/providerSelectors';
import { listProviders } from './../../redux/actions/provider';
import { formatDate } from "../../utils/utils";
import DataTable from "../../ui/DataTable/DataTable";

const ApiProviders = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectProvidersLoading);
  const providerList = useSelector(selectProvidersData);

  useEffect(() => {
    dispatch(listProviders());
  }, [dispatch]);

  const prepareDataToExport = () => {
    let data = providerList.map(item => {
      return {
        "Provider Name": item?.name,
        "Description": item?.description,
        "Date": formatDate(item?.created_at)
      };
    });

    return data;
  };


  return (
    <ProgressLoader isLoading={isLoading}>
      <div className="ApiProviders">
    
        <SapaHeader page={"API Providers"} />
        <Card className="sapa-apiproviders__container">
          <Filterbox 
            displayFilter={"none"}
            searchIsLoading={isLoading}
            searchAction={listProviders}
            exportFileName="providers.csv"
            dataToExport={prepareDataToExport}
            showExportButton={false}
          />
          <DataTable
            dataSource={providerList}
            columns={apiProvidersColumn}
            scrollX={820}
          />
        </Card>
      </div>
    </ProgressLoader>
  );
};

export default ApiProviders;
